import SingleOrder from "./SingleOrder";
import BulkOrder from "./BulkOrder";
import CompetitionOrderConfig from "../CompetitionOrderConfig/CompetitionOrderConfig";
import FundSellSettings from "../FundSellSettings/FundSellSettings";

const StepAddOrderBox = () => {
  return (
    <div className="flex flex-col justify-start items-center gap-3">
      <CompetitionOrderConfig />
      <FundSellSettings />
      <SingleOrder />
      <BulkOrder />
    </div>
  );
};

export default StepAddOrderBox;
